module.exports = __webpack_public_path__ + "static/media/vid1.6ec96dda.mp4";